import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OverlayService {
    private idElementoDisposto$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    public registra(idElemento: string): Observable<string | null> {
        this.idElementoDisposto$.next(idElemento);
        return this.idElementoDisposto$.asObservable().pipe(filter((id) => id === null || id !== idElemento));
    }

    public fecha(): void {
        if (this.existeElementoDisposto()) {
            this.idElementoDisposto$.next(null);
        }
    }

    public existeElementoDisposto(): boolean {
        return this.idElementoDisposto$.value !== null;
    }
}
